import React from 'react';
import { type RouteComponentProps } from '@gatsbyjs/reach-router';
import { useGetLfaConversionsTotalsQuery } from '~/graphql/types';
import { Helmet as MetaTags } from 'react-helmet';
import createPageTitle from '~/util/createPageTitle';
import ContentContainerDefault from '~/components/molecule/ContentContainer';
import OverviewListHeader from '~/components/molecule/OverviewListHeader';
import Loading from '~/components/atom/Loading';
import ErrorScreen from '../ErrorScreen';
import Content from './components/Content';
import EmptyStateComponent from '~/components/template/EmptyStateComponent';
import ConversionPage from '~/components/template/ConversionPage';
import useSessionHydration from '~/hooks/useSessionHydration';

const text = {
  pageTitle: 'LeadAssist',
  emptyStateHeader: 'Geen afspraken gevonden',
};

const LFA: React.FCC<RouteComponentProps> = () => {
  const [sessionHydrationData] = useSessionHydration();
  const { id: accountId } = sessionHydrationData.account;

  const {
    data: totals,
    loading: totalsLoading,
    error: totalsError,
    refetch,
  } = useGetLfaConversionsTotalsQuery({
    variables: {
      accountId,
    },
  });

  if (totalsLoading) return <Loading />;
  if (totalsError || !totals) return <ErrorScreen />;

  if (sessionHydrationData.lfaEnabled !== true)
    return <ConversionPage slug="leadassist" />;

  const hasAnyConversions = Object.keys(totals).some(
    key => totals[key].total > 0,
  );

  return (
    <>
      <MetaTags>
        <title>{createPageTitle(text.pageTitle)}</title>
      </MetaTags>
      <ContentContainerDefault maxContentWidth="1400px">
        <OverviewListHeader title={text.pageTitle} />

        {hasAnyConversions ? (
          <Content accountId={accountId} totals={totals} refetch={refetch} />
        ) : (
          <EmptyStateComponent header={text.emptyStateHeader} />
        )}
      </ContentContainerDefault>
    </>
  );
};

export default LFA;
